export const COMMANDS_AIRCRAFT_VIEW = 'commands.aircraft:view';
export const FLIGHT_COMMANDS_SEND = 'mc-flight-commands:send';
export const PRIORITY_EVENTS_ACKNOWLEDGE = 'priority-events:acknowledge';
export const APPLICATION_ACCESS_PERMISSION =
  'app.mission-control-next-gen:access';
